import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'vs-spinner',
  styleUrl: 'vs-spinner.css',
  shadow: false,
})
export class VsSpinner {
  @Prop() size: number;
  @Prop() diameter: number;
  @Prop() value;

  offset: number = 0;
  radius: number;
  circumference: number;
  strokeDashArray: string;
  origin: number;

  connectedCallback() {
    this.origin = this.size / 2;
    this.radius = this.diameter / 2;
    this.circumference = this.radius * 2 * Math.PI;
    this.strokeDashArray = `${this.circumference} ${this.circumference}`;
    this.offset = this.circumference;
  }

  componentDidUpdate() {
    this.offset = this.circumference - (this.value / 100) * this.circumference;
  }


  render() {
    return (
      <Host>
        <div class="vs-progress-ring-base" style={{ height: this.size.toString(), width: this.size.toString(), position: "absolute" }}>
          <svg class="progress-ring" style={{ width: this.diameter.toString(), height: this.diameter.toString() }}><circle fill="transparent" class="vs-progress-ring" stroke-width="3" r="6.5" cx="8.5" cy="8.5" style={{ strokeDasharray: this.strokeDashArray, strokeDashoffset: "0" }}></circle></svg>
        </div>
        <div class="vs-progress-ring-loader" style={{ height: this.size.toString(), width: this.size.toString(), position: "absolute" }}>
          <svg class="progress-ring" style={{ width: this.diameter.toString(), height: this.diameter.toString() }}><circle fill="transparent" class="vs-progress-ring" stroke-width="4" r="6.5" cx="8.5" cy="8.5" style={{ strokeDasharray: this.strokeDashArray, strokeDashoffset: this.offset.toString() }}></circle></svg>
        </div>
      </Host>
    );
  }

}
